// Stadia Maps tile configuration. API key is read from REACT_APP_STADIA_API_KEY.
const STADIA_KEY = process.env.REACT_APP_STADIA_API_KEY || "";

const STADIA_ATTRIBUTION =
  '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a> ' +
  '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> ' +
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

const FALLBACK_OSM = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const FALLBACK_ATTR = "&copy; OpenStreetMap";

// theme: "dark" | "light"
export function tileUrl(theme = "dark") {
  if (!STADIA_KEY) return FALLBACK_OSM;
  const style = theme === "dark" ? "alidade_smooth_dark" : "alidade_smooth";
  return `https://tiles.stadiamaps.com/tiles/${style}/{z}/{x}/{y}{r}.png?api_key=${STADIA_KEY}`;
}

export function tileAttribution() {
  return STADIA_KEY ? STADIA_ATTRIBUTION : FALLBACK_ATTR;
}

export const TILE_MAX_ZOOM = 20;
